import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/board/request?page=1&maxData=99999999' // (1) 게시글(업무요청글) 목록 조회

let swrData: any = getPersistData(KEY)

export function useBoardList(deptId, category, status, searchWord, createdAt) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		`${KEY}${searchWord ? '&searchWord=' + searchWord : ''}${createdAt ? '&createdAt=' + createdAt : ''}${status !== '전체' ? '&status=' + status : ''}${category !== 0 ? '&categoryId=' + category : ''}${(deptId !== 0) && (deptId !== null) ? '&deptId=' + deptId : ''}`,
		async (url) => {
			const response = await API.get(url, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		boardList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}